module.exports = __webpack_public_path__ + "static/media/4.3e410d6f.jpg";